import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Tendance positive — flèche montante duotone */
export const TrendingUpIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Zone sous la courbe menthe */}
      <path
        d="M3 19V13l5.5 3 5-7 7.5 5v5H3z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.55"
      />
      {/* Courbe montante */}
      <path
        d="M3 16l5.5-3 5-5 7.5-3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Flèche pointe */}
      <path
        d="M16 5h5v5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
TrendingUpIcon.displayName = "TrendingUpIcon";
